import { render, staticRenderFns } from "./waiting-call-list.vue?vue&type=template&id=1321ac4d&"
import script from "./waiting-call-list.vue?vue&type=script&lang=js&"
export * from "./waiting-call-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports